import { Id } from "./id";

type AccountCreationConfirmationRequest = {
  userId: Id;
  password: string;
  passwordConfirmation: string;
  username: string;
  companyName: string;
  title: string;
  address: string;
  planzone: {
    name: string;
    domain: string;
  };
  hasRequestedPlanzoneCreation: boolean;
};

const accountCreationConfirmationRequest: AccountCreationConfirmationRequest = {
  userId: "",
  address: "",
  companyName: "",
  hasRequestedPlanzoneCreation: false,
  password: "",
  passwordConfirmation: "",
  planzone: { domain: "", name: "" },
  title: "",
  username: "",
};

export type { AccountCreationConfirmationRequest };

export { accountCreationConfirmationRequest };
